import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Input, Table, Modal, message, Tooltip, Button, Switch, Popconfirm, Form } from "antd";
import { DownloadOutlined, PlusOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspectionnew'
import { stationApi, } from "@api/newApi";
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData } from '@utils/common'
import AddModel from './add'
import DogImg from './dog.jpg'
import '../style.scss'

const TaskCom = (props) => {
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [totalData, setTotalData] = useState({})
  const [editTitle, setEditTitle] = useState('新增捡漏')
  const [rowParams, setRowParams] = useState()

  // 驳回意见弹出层显示与隐藏
  const [rejectModalVisible,setrejectModalVisible] = useState(false)
  // 驳回意见文件框
  const [rejectIpt,setRejectIpt] = useState('')

  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)
  
  // 搜索
const [inputList] = useState([{
  label: '巡检人:',
  name: "createByName",
  message: "请输入巡检人",
  span: 8,
  labelCol: 6
}])

// 时间选择器
const [ dateSearch ] = useState([{
  label: '时间',
  name: 'time',
  span: 8,
  labelCol: 6,
  tag: 'rangePicker'
}])

// 设置下拉菜单
const [selectList, setSelectList] = useState()
const [stationData, setStationData] = useState()

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6
      },
      {
        attr: { allowClear: true },
        label: '是否提交漏检原因:',
        name: "status",
        message: "请选择",
        options: [{ title: '否', value: 0, checked: false }, { title: '是', value: 1, checked: false }],
        span: 8,
        labelCol: 10
      },
      {
        attr: { allowClear: true },
        label: '漏检状态:',
        name: "status",
        message: "请选择",
        options: [{ title: '同意', value: 1, checked: false }, { title: '驳回', value: 0, checked: false }],
        span: 8,
        labelCol: 12
        // 驳回要显示驳回原因
      }
      // {
      //   attr: { allowClear: true },
      //   label: '状态:',
      //   name: "status",
      //   message: "请选择状态",
      //   options: [{ title: '停用', value: 0, checked: false }, { title: '启用', value: 1, checked: false }],
      //   span: 8,
      //   labelCol: 6
      // },
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(false)
    // const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    // InspectionApi.taskLeakList({ ...searchParams, }).then(res => {
    //   setLoading(false)
    //   if (res.status == 0 && res.data) {
    //     res.data.data.unshift({
    //       taskName: '任务名称',
    //       stationAliasName: '玄滩',
    //       taskDate: '2022/02/23',
    //       reason: {
    //         img: DogImg,
    //         text: '原因描述'
    //       }
    //     })
    //     setData(res.data.data || [])
    //     setTotal(res.data.total)
    //   }
    // })
    const data = [{
      taskName: '任务名称',
      stationAliasName: '玄滩',
      taskDate: '2022/02/23',
      reason: {
        img: DogImg,
        text: '原因描述'
      }
    }]
    // res.data.data.unshift({
    //   taskName: '任务名称',
    //   stationAliasName: '玄滩',
    //   taskDate: '2022/02/23',
    //   reason: {
    //     img: DogImg,
    //     text: '原因描述'
    //   }
    // })
    setData(data)
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, 'paramsObj')
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectionApi.delete(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    InspectionApi.updateStatus({ id: (info.id * 1), status: info.status === 0 ? 1 : 0 }).then(res => {
      if (res.status === '0') {
        message.success('修改成功')
        listByRole()
      }
    })
  }

  // 驳回弹出
  const rejectComfirm = () => {
    setrejectModalVisible(true)
  }

  const handlerFormItem = (e) => {
    setRejectIpt(e.target.value)
  }

  // 
  const submiteRejectComfirm = () => {

  }

  // 驳回弹出取消
  const canCelrejectComfirm = () => {
    setrejectModalVisible(false)
  }


  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    onClick: () => {
      setEditVisible(true)
      setRowParams(null)
    }
  }]

  const columns = [
    {
      title: '任务名称',
      dataIndex: 'taskName',
      align: 'center',
      key: 'taskName',
      render: _t => <Tooltip placement="top" title={_t}>{_t.length > 6 ? _t.substring(0, 5) + '…' : _t}</Tooltip>
    },
    // {
    //   title: '巡检计划',
    //   dataIndex: 'planName',
    //   align: 'center',
    //   key: 'planName',
    // },
    {
      title: '厂站',
      dataIndex: 'stationAliasName',
      align: 'center',
      key: 'stationAliasName',
    },
    {
      title: '任务日期',
      dataIndex: 'taskDate',
      align: 'center',
      key: 'taskDate',
    },
    {
      title: '原因提交',
      dataIndex: 'reason',
      align: 'center',
      key: 'reason',
      render: (obj) => {
        return (
          <>
            <a href={obj.img} target="_blank"><img src={obj.img} width={100} /></a>
            <p>{obj.text}</p>
          </>
        )
      }
    },
    {
      title: '处理意见',
      dataIndex: 'opinion',
      align: 'center',
      key: 'opinion',
      render: (obj,record) => {
        return (
          <>
            <Button size='small' type='primary'>同意</Button>
            <Button size='small' onClick={rejectComfirm} style={ {marginLeft: '5px'} } danger>驳回</Button>         
          </>
        )
      }
    },
    {
      title: '责任人',
      dataIndex: 'patrolUserName',
      align: 'center',
      key: 'patrolUserName',
    }
    // {
    //   title: '巡检人员',
    //   dataIndex: 'patrolUserName',
    //   align: 'center',
    //   key: 'patrolUserName',
    // },
    // {
    //   title: '设备',
    //   dataIndex: 'deviceName',
    //   align: 'center',
    //   key: 'deviceName',
    // },
    // {
    //   title: '开始时间',
    //   dataIndex: 'beginTime',
    //   align: 'center',
    //   key: 'beginTime',
    //   render: (obj) => {
    //     if (obj) {
    //       return (
    //         moment(obj).format('YYYY-MM-DD')
    //       )
    //     }
    //   }
    // },
    // {
    //   title: '结束时间',
    //   dataIndex: 'endTime',
    //   align: 'center',
    //   key: 'endTime',
    //   render: (obj) => {
    //     if (obj) {
    //       return (
    //         moment(obj).format('YYYY-MM-DD')
    //       )
    //     }
    //   }
    // },
    // {
    //   title: '操作',
    //   key: 'operation',
    //   // width: '200px',
    //   // fixed: 'right',
    //   render: (obj, record) => {
    //     return (
    //       <>
    //         {/* <Popconfirm
    //           title={`确定要${obj.status === 0 ? '启用' : '禁用'}模版吗？`}
    //           onConfirm={() => handleConfirm(record)}
    //           // onCancel={cancel}
    //           okText="确定"
    //           cancelText="取消"
    //         >
    //           <Button size='small' type="primary">{obj.status === 0 ? '启用' : '禁用'}</Button>
    //         </Popconfirm> */}
    //         <Button
    //           style={{ marginLeft: '5px' }}
    //           onClick={() => {
    //             setDelVisible(true)
    //             setRowParams(record)
    //           }
    //           }
    //           size='small'
    //           type='primary'>详情
    //         </Button>
    //       </>
    //     )
    //   }
    // }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="厂站列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm dateSearch={dateSearch} inputList={inputList} searchParams={searchParams} span={6} selectList={selectList} onSearch={search} />
        </div>
        {/* <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} /> */}
        <div >
          <Table
            className='Table'
            // scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='详情'
            width={600}
            open={deleteVisible}
            onCancel={cancel}
            // confirmLoading={loadBtn}
            onOk={cancel}
          >
            <Form.Item label='任务名称'>
              {rowParams.taskName}
            </Form.Item>
            <Form.Item label='巡检计划'>
              {rowParams.planName}
            </Form.Item>
            <Form.Item label='巡检厂站'>
              {rowParams.stationName}
            </Form.Item>
            <Form.Item label='巡检人员'>
              {rowParams.patrolUserName}
            </Form.Item>
            <Form.Item label='开始时间'>
              {rowParams.beginTime}
            </Form.Item>
          </Modal>
        }
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
      {/* 驳回意见弹出层 */}
      <Modal title="驳回意见" open={rejectModalVisible} onOk={submiteRejectComfirm} onCancel={ canCelrejectComfirm }>
        <Input placeholder="请输入驳回意见" onChange={ (e) => handlerFormItem(e) }></Input>
      </Modal>
    </div >
  )
}
const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(TaskCom)
